import { Box, Table, TableBody, TableCell, TableHead, TableRow } from "@mui/material";
import InboxOutlinedIcon from "@mui/icons-material/InboxOutlined";
import { BauCuaMascotBadge } from "./BauCuaMascotIcons";

const LABELS = {
    baccarat: { p: "Player", player: "Player", con: "Player", b: "Banker", banker: "Banker", cai: "Banker", t: "Tie", tie: "Tie", hoa: "Tie" },
    xocdia: { chan: "Chẵn", le: "Lẻ", "4trang": "4 Trắng", "3trang1do": "3 Trắng 1 Đỏ", "2do2trang": "2 Đỏ 2 Trắng", "3do1trang": "3 Đỏ 1 Trắng", "4do": "4 Đỏ" },
    rongho: { rong: "Rồng", dragon: "Rồng", hoa: "Hòa", tie: "Hòa", ho: "Hổ", tiger: "Hổ" }
};

const label = (game, value) => LABELS[game]?.[String(value || "").toLowerCase()] || value || "-";

export default function BlockchainClassicSummary({ game, bets = [] }) {
    const rows = Array.isArray(bets) ? bets : [];
    const totals = rows.reduce((output, item) => {
        const key = String(item?.state || item?.cuadat || item?.type || "-");
        output[key] = (output[key] || 0) + Number(item?.money || 0);
        return output;
    }, {});

    return <div className={`classic-bet-overview classic-bet-overview--${game}`}>
        {game !== "baucua" && <section className="classic-bet-total">
            <h3>Tổng các cửa đặt</h3>
            <div className="classic-empty-bet">
                {Object.keys(totals).length ? Object.entries(totals).map(([key, value]) => <div key={key}><span>{label(game, key)}</span><strong>{Number(value || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}</strong></div>) : <><b>$</b><span>Chưa có lệnh cược</span></>}
            </div>
        </section>}
        <section className="classic-bet-players">
            <h3>Thống kê đặt cược</h3>
            <Box className="classic-bet-table-scroll">
                <Table size="small">
                    <TableHead><TableRow>
                        <TableCell>Tài khoản</TableCell><TableCell>Thể loại</TableCell>
                        {game === "baucua" && <TableCell>Kiểu</TableCell>}
                        {game === "baucua" && <TableCell>Cửa đặt</TableCell>}
                        {game !== "baucua" && <TableCell>Đặt cược</TableCell>}
                        <TableCell>Số điểm</TableCell>
                    </TableRow></TableHead>
                    <TableBody>{rows.length ? rows.map((item, index) => <TableRow key={item?._id || index}>
                        <TableCell>{item?.user?.username || item?.user?.name || "-"}</TableCell>
                        <TableCell>{game === "baucua" ? "Bầu cua" : label(game, item?.state)}</TableCell>
                        {game === "baucua" && <TableCell>{item?.type || "Thường"}</TableCell>}
                        {game === "baucua" && <TableCell>{item?.state || item?.cuadat || "-"}</TableCell>}
                        {game !== "baucua" && <TableCell>{label(game, item?.state)}</TableCell>}
                        <TableCell>{Number(item?.money || 0).toLocaleString("vi-VN", { maximumFractionDigits: 2 })}</TableCell>
                    </TableRow>) : <TableRow><TableCell colSpan={game === "baucua" ? 5 : 4} align="center"><div className="classic-empty-table"><InboxOutlinedIcon /><span>Trống</span></div></TableCell></TableRow>}</TableBody>
                </Table>
            </Box>
        </section>
        {game === "baucua" && <div className="classic-baucua-symbols">
            {[1, 2, 3, 4, 5, 6].map(id => (
                <BauCuaMascotBadge key={id} id={id} />
            ))}
        </div>}
    </div>;
}
